/*
 *
 * GenericToast
 *
 * @version 1.0.0
 * @author tfrazzet
 * @since 18-Sep-2024
*/

import GenericToast from './GenericToastContainer'

export default GenericToast
